<div id="peaks-container">
    <canvas baseChart
            [datasets]="lineChartData"
            [labels]="lineChartLabels"
            [options]="lineChartOptions"
            legend="true"
            chartType="line">
    </canvas>
</div>
